import {detailServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = detailServicesPath + '/organizations/compositions/modules/relate-details'
const restUrlPattern = detailServicesPath + '/organizations/compositions/relate-details'

export default class RelateDelailController {
    static async savePattern(moduleId, detailPatternId, detailId, data) {
        return await axios.post(restUrlPattern + "?moduleId=" + moduleId + "&detailPatternId=" + detailPatternId + "&detailId=" + detailId, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deletePattern(id) {
        await axios.delete(restUrlPattern + '/' + id);
    }

    static async save(moduleId, detailId, data) {
        return await axios.post(restUrl + "?moduleId=" + moduleId + "&detailId=" + detailId, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id);
    }
}